import styled from 'styled-components';

export const ContainerButtonsZones = styled.div`
  width: '110px';
`;
